import React from 'react';
import { useParams } from 'react-router-dom';

const JobApplication = () => {
    const { jobId } = useParams();

    const handleApplyClick = () => {
        const recipientEmail = "recruit@ensuresap.com";
        const subject = encodeURIComponent("Job Application for Position " + jobId);
        const body = encodeURIComponent("Dear Recruiter,\n\nI am interested in applying for the position. Please find my details below:\n\nName: \nEmail: \nPhone: \nLinkedIn Profile: \n\nBest Regards,\n");
        
        window.location.href = `mailto:${recipientEmail}?subject=${subject}&body=${body}`;
    };

    return (
        <div className="container mx-auto py-10 px-4 text-center">
            <div className="bg-white p-6 rounded-lg shadow-md max-w-lg mx-auto">
                <h1 className="text-2xl font-bold mb-4">Apply for Job</h1>
                <p className="mb-4">Click the button below to compose an email for your job application.</p>
                <button onClick={handleApplyClick} className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700">
                    Apply Now
                </button>
            </div>
        </div>
    );
};

export default JobApplication;
